import { useState, useCallback, useEffect } from 'react';
import { formatSignature } from '../utils/dateUtils';

export const useSignature = ({ setValue, handleSubmit, onSubmit }) => {
    const [isSignatureModalOpen, setIsSignatureModalOpen] = useState(false);
    const [signerName, setSignerName] = useState("");
    const [submitAfterSign, setSubmitAfterSign] = useState(false);
    const [signatureType, setSignatureType] = useState(null); // 'employee' or 'admin'

    const formatElectronicSignature = (name) => {
        return formatSignature(name);
    };

    const getInitialName = useCallback(() => {
        try {
            const currentUserStr = localStorage.getItem("currentUser");
            if (currentUserStr) {
                const user = JSON.parse(currentUserStr);
                if (user.firstName) {
                    return user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;
                } else if (user.name) {
                    return user.name;
                } else if (user.applicantName) {
                    return user.applicantName;
                }
            }
        } catch (e) {
            console.error("Error parsing current user", e);
        }
        return "";
    }, []);

    useEffect(() => {
        setSignerName(getInitialName());
    }, [getInitialName]);

    const openSignatureModal = useCallback((type = 'employee', shouldSubmit = false) => {
        setSignatureType(type);
        setSubmitAfterSign(typeof type === 'boolean' ? type : shouldSubmit);

        const initialName = getInitialName();
        setSignerName(initialName);
        setIsSignatureModalOpen(true);
    }, [getInitialName]);

    const closeSignatureModal = useCallback(() => {
        setIsSignatureModalOpen(false);
        setSignerName("");
        setSubmitAfterSign(false);
        setSignatureType(null);
    }, []);

    const saveSignature = useCallback(() => {
        if (!signerName || signerName.trim() === "") return;

        const formattedSignature = formatElectronicSignature(signerName.trim());

        return {
            formattedSignature,
            signerName: signerName.trim(),
            submitAfterSign,
            signatureType
        };

    }, [signerName, submitAfterSign, signatureType]);

    return {
        isSignatureModalOpen,
        openSignatureModal,
        closeSignatureModal,
        signerName,
        setSignerName,
        saveSignature,
        signatureType,
        formatElectronicSignature
    };
};
